import { Badge, Flex, Progress } from "@mantine/core";
import { AverageSubjectGradeBoundariesSchema } from "@tsTypes/subject-schema";
import { roundTo1DP } from "@utils/helpers";
import { convertPercentageToGrade } from "@utils/meta";
import { convertSecondsToHoursMinsString } from "../../../../../../../../lib/stripe/formatters";
import classes from "./TestPerformanceSummary.module.css";

export default function TestPerformanceSummary({
  totalMarks,
  achievedMarks,
  timeSpent,
  totalTime,
  subjectGradeBoundaries,
}: {
  totalMarks: number;
  achievedMarks: number;
  timeSpent: number;
  totalTime: number;
  subjectGradeBoundaries: AverageSubjectGradeBoundariesSchema[string];
}) {
  const percentagePerformance = roundTo1DP((achievedMarks / totalMarks) * 100);

  return (
    <Flex gap="sm" className={classes.flexWrapper}>
      <PerformanceBadge
        mainMetric={`${percentagePerformance}%`}
        metricLabel={`Grade ${convertPercentageToGrade(
          percentagePerformance,
          subjectGradeBoundaries.SL
        )}`}
        barPercentage={percentagePerformance}
        coloured={true}
      />
      <PerformanceBadge
        mainMetric={achievedMarks.toString()}
        metricTotal={totalMarks.toString()}
        metricLabel="marks"
        barPercentage={(achievedMarks / totalMarks) * 100}
      />
      <PerformanceBadge
        mainMetric={convertSecondsToHoursMinsString(timeSpent, true)}
        metricTotal={convertSecondsToHoursMinsString(totalTime)}
        metricLabel="used"
        barPercentage={(timeSpent / totalTime) * 100}
      />
    </Flex>
  );
}

function PerformanceBadge({
  mainMetric,
  metricTotal,
  metricLabel,
  barPercentage,
  coloured,
}: {
  mainMetric: string;
  metricTotal?: string;
  metricLabel: string;
  barPercentage: number;
  coloured?: true;
}) {
  return (
    <Badge className={classes.badge}>
      <span className={classes.mainMetric}>{mainMetric}</span> /{" "}
      {metricTotal ?? ""} {metricLabel}
      <Progress.Root size="xs" classNames={{ root: classes.progressBarRoot }}>
        {coloured ? (
          <>
            <Progress.Section
              value={barPercentage}
              color="correct"
              className={classes.progressBar}
            />
            <Progress.Section
              value={100 - barPercentage}
              color="incorrect"
              className={classes.progressBar}
            />
          </>
        ) : (
          <Progress.Section
            value={barPercentage}
            color="white"
            className={classes.progressBar}
          />
        )}
      </Progress.Root>
    </Badge>
  );
}

export const useProgressBarStyles = () => ({ classes });
